var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tabsComp"}},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index},[_c('button',{class:['tab', tab.active?'active':''],on:{"click":function($event){return _vm.tabClick(tab.data)}}},[_vm._v(_vm._s(tab.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }